import Vue from 'vue'
import Vuex from 'vuex'
import { createModule } from 'vuex-toast'
import 'vuex-toast/dist/vuex-toast.css'
import { StoreChatConfig, StoreChat } from '@cedro-technologies/people-vue-ui'
import * as actions from './modules/cleanStorage'
import Bot from './modules/bot'
import SettingsWebchat from './modules/settingsWebchat'
import SocketIO from './modules/socketIO'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  modules: {
    Bot,
    SocketIO,
    SettingsWebchat,
    StoreChatConfig,
    StoreChat,
    toast: createModule({
      dismissInterval: 4000
    })
  },
  strict: false
})
